export var AbstractRoute = {
    render: function (createElement) { return createElement('router-view'); }
};
